import * as Toast from '@radix-ui/react-toast';
import type { ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';

import { Portal } from '#src/atoms/layout/Portal/index.tsx';
import { theme } from '#src/style/theme.tsx';

const slideDown = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(var(--radix-toast-swipe-end-y));
    opacity: 1;
  }
`;
const slideUp = keyframes`
  from {
    transform: translateY(var(--radix-toast-swipe-end-y));
  }
  to {
    transform: translateY(-100%);
    opacity: 0;
  }
`;

const Root = styled(Toast.Root)`
  pointer-events: auto;
  &[data-state='open'] {
    animation: ${slideDown} 700ms cubic-bezier(0.02, 0.36, 0.48, 0.97);
  }
  &[data-swipe='move'] {
    transform: translateY(var(--radix-toast-swipe-move-y));
  }
  &[data-swipe='cancel'] {
    transform: translateY(0);
    transition: transform 200ms ease-out;
  }
  &[data-state='closed'],
  &[data-swipe='end'] {
    animation: ${slideUp} 250ms ease-out;
  }
  &:focus {
    outline: none;
  }
`;

const Viewport = styled(Toast.Viewport)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${theme.zIndex.snackbar};
  display: flex;
  flex-direction: column;
  padding: var(--double-unit);
  margin: 0; /** Viewport is an ol element that adds margin */
  pointer-events: none;
`;

type Props = { className?: string; children: ReactNode } & Toast.ToastProps;
export const ToastBase = ({ className, children, ...props }: Props) => {
  return (
    <Toast.Provider swipeDirection="up" swipeThreshold={24}>
      <Root {...props} className={className}>
        {children}
      </Root>
      <Portal id="snackbar">
        <Viewport />
      </Portal>
    </Toast.Provider>
  );
};
